var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCoffee = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M6.66675 13.3333L9.34841 30.76C9.72341 33.2 11.8217 35 14.2901 35H25.7101C28.1784 35 30.2767 33.2 30.6517 30.76L33.3334 13.3333H6.66675Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33341 13.3333H31.6667C32.5867 13.3333 33.3334 12.5867 33.3334 11.6667V10C33.3334 7.23833 31.0951 5 28.3334 5H11.6667C8.90508 5 6.66675 7.23833 6.66675 10V11.6667C6.66675 12.5867 7.41341 13.3333 8.33341 13.3333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 8.33331H11.6667L12.5734 5.61331C13.0267 4.25165 14.3017 3.33331 15.7367 3.33331H24.2651C25.7001 3.33331 26.9734 4.25165 27.4267 5.61331L28.3334 8.33331Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333C22.7614 28.3333 25 26.0947 25 23.3333C25 20.5719 22.7614 18.3333 20 18.3333C17.2386 18.3333 15 20.5719 15 23.3333C15 26.0947 17.2386 28.3333 20 28.3333Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 13.3333H6.66667C5.745 13.3333 5 12.5883 5 11.6667C5 10.745 5.745 10 6.66667 10H33.3333C34.255 10 35 10.745 35 11.6667C35 12.5883 34.255 13.3333 33.3333 13.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoffee, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coffee.61e42d0a.svg";
export { ForwardRef as ReactComponent };